import sampleService from '../../api/sample'
import webSocketPrintService from '../../api/webSocketPrint'

import {
  SAMPLE_SET_LOADING_STATUS,
  SAMPLE_SET,
  SAMPLE_INCREASE_OFFSET,
  SAMPLE_SET_NOT_PRINTED,
  SAMPLE_SET_PRINTED_NUMBER,
  SAMPLE_CLEAR_ALL,
  SAMPLE_SHOW_DETAILS,
  SAMPLE_SET_PRINTED_LIST,
  SAMPLE_SET_PRINTING_STATUS,
  SAMPLE_SORT_LIST,
  SAMPLE_TOTAL_COUNT,
  SAMPLE_FILTER_SHOW_OFF,
  SAMPLE_BREAK_STATUS,
  SAMPLE_SET_CURRENT_TAB,
  SAMPLE_SET_TOTAL_EXAMS_DOC_PENDING,
  SAMPLE_SET_PRINTED,
  SAMPLE_SET_INTEGRATED,
} from '../types'
import notify from '../../api/notification'
import analytics from '../../api/analytics'
import { getCookie } from '../../utils/auth-utils'
import { SAMPLE_PRINTED, eventBus } from '@/api/eventbus'
import strings from '@/strings'
import { sortColumn } from '../../utils/sort-columns'
import { getCustomDateLabel } from '../../utils/date-utils'
import PrintWebSocketService from '@/services/PrintWebSocketService'

const state = {
  sampleCurrentTab: 'aol20',
  sampleLoadingStatus: 'STATUS_INITIAL',
  samplePrintingStatus: 'STATUS_INITIAL',
  samples: [],
  offset: 0,
  printedSamples: 0,
  notPrintedSamples: 0,
  samplePrintedList: Boolean,
  profile: getCookie('profile') || null,
  startDate: null,
  endDate: null,
  orderBy: null,
  dateType: null,
  patientName: null,
  codeOriginAlvaro: null,
  codeOriginLis: null,
  batchLabel: null,
  integrated: '',
  printed: '',
  sampleStatus: undefined,
  source: undefined,
  collectionPointName: null,
  filterShowOff: false,
  q: null,
  idFile: null,
  docDelivered: null,
  lastReordenationSample: {
    sort: null,
    column: null,
  },
  totalSampleCount: {
    aol20: 0,
    aolWs: 0,
  },
  breakStatusSamples: false,
  totalSamplesExamsWithDocumentsPending: 0,
  processingOrigin: null,
  idRecollect: null,
  limitDaysSamples: 20,
  pending: false,
}

const mutations = {
  [SAMPLE_SET_LOADING_STATUS](state, sampleLoadingStatus) {
    state.sampleLoadingStatus = sampleLoadingStatus
  },
  [SAMPLE_SET](state, samples) {
    state.samples = samples
  },
  [SAMPLE_SET_NOT_PRINTED](state, notPrintedSamples) {
    state.notPrintedSamples = notPrintedSamples
  },
  [SAMPLE_SET_PRINTED_NUMBER](state, printedSamples) {
    state.printedSamples = printedSamples
  },
  [SAMPLE_INCREASE_OFFSET](state) {
    state.offset++
  },
  [SAMPLE_CLEAR_ALL](state) {
    state.samples = []
    state.offset = 0
    state.printedSamples = 0
    state.notPrintedSamples = 0
    state.lastReordenationSample = {
      sort: null,
      column: null,
    }
  },
  [SAMPLE_FILTER_SHOW_OFF](state, value) {
    state.filterShowOff = value
  },
  [SAMPLE_SHOW_DETAILS](state, index) {
    state.samples[index].expanded = !state.samples[index].expanded
  },
  [SAMPLE_SET_PRINTED_LIST](state, query) {
    state.samples = []
    state.offset = 0
    state.startDate = query.startDate
    state.endDate = query.endDate
    state.orderBy = query.orderBy || 'OSID'
    state.q = query.q
    state.samplePrintedList = routeStringtoBoolean(query.printed)
    state.dateType = query.dateType
    state.patientName = query.patientName
    state.batchLabel = query.batchLabel
    state.codeOriginLis = query.codeOriginLis
    state.codeOriginAlvaro = query.codeOriginAlvaro
    state.idFile = query.idFile
    state.docDelivered = query.docDelivered
    state.packagingType = query.packagingType
    state.processingOrigin = query.processingOrigin
    ;((state.idRecollect = query.idRecollect),
      (state.collectionPointName = query.collectionPointName))
    state.integrated = query.integrated
    state.printed = query.printed
    state.sampleStatus = query.sampleStatus
    state.source = query.source
  },
  [SAMPLE_SET_PRINTING_STATUS](state, samplePrintingStatus) {
    state.samplePrintingStatus = samplePrintingStatus
  },
  [SAMPLE_SORT_LIST](state, param) {
    state.lastReordenationSample = param
    let temporaryArray = state.samples
    state.samples = []

    if (param.sort === 'asc') {
      state.samples = temporaryArray.sort(
        sortColumn(param.column, param.columnChild, 'one-field-level')
      )
    } else {
      state.samples = temporaryArray.reverse(
        sortColumn(param.column, param.columnChild, 'one-field-level')
      )
    }
  },
  [SAMPLE_TOTAL_COUNT](state, count) {
    state.totalSampleCount = count
  },
  [SAMPLE_BREAK_STATUS](state, value) {
    state.breakStatusSamples = value
  },
  [SAMPLE_SET_TOTAL_EXAMS_DOC_PENDING](state, value) {
    state.totalSamplesExamsWithDocumentsPending = value
  },
  [SAMPLE_SET_CURRENT_TAB](state, value) {
    state.sampleCurrentTab = value
  },
  [SAMPLE_SET_PRINTED](state, value) {
    state.printed = value
  },
  [SAMPLE_SET_INTEGRATED](state, value) {
    state.integrated = value
  },
}

const getters = {
  sampleLoadingStatus: state => {
    return state.sampleLoadingStatus
  },
  samples: state => {
    return state.samples
  },
  samplesoffset: state => {
    return state.offset
  },
  printedSamples: state => {
    return state.printedSamples
  },
  notPrintedSamples: state => {
    return state.notPrintedSamples
  },
  samplePrintedList: state => {
    return state.samplePrintedList
  },
  hasSamples: state => {
    return state.samples && state.samples.length > 0
  },
  samplesLoading: state => {
    return state.sampleLoadingStatus === 'STATUS_INITIAL'
  },
  samplePrintingStatus: state => {
    return state.samplePrintingStatus
  },
  isSampleFilterShowing: state => {
    return state.filterShowOff
  },
  totalSamples: state => {
    let total = state.totalSampleCount.aol20
    total += state.totalSampleCount.aolws > 0 ? state.totalSampleCount.aolws : 0
    return total
  },
  samplesBreakStatus: state => {
    return state.breakStatusSamples
  },
  totalSampleExamsWithDocumentsPending: state => {
    return state.totalSamplesExamsWithDocumentsPending
  },
  samplesCounters: state => {
    return state.totalSampleCount
  },
  samplesCurrentTab: state => {
    return state.sampleCurrentTab
  },
  samplesDateImportPeriodXMLFormated: state => {
    const start = state.dateImportPeriodXML?.start
    const end = state.dateImportPeriodXML?.end
    return getCustomDateLabel(start, end)
  },
  samplesStateDataSelected: state => ({
    offset: state.offset,
    samplesListLimit: strings.listsLimits.samples,
    samplePrintedList: state.samplePrintedList,
    startDate: state.startDate,
    endDate: state.endDate,
    orderBy: state.orderBy,
    query: state.q,
    dateType: state.dateType,
    patientName: state.patientName,
    batchLabel: state.batchLabel,
    codeOriginLis: state.codeOriginLis,
    codeOriginAlvaro: state.codeOriginAlvaro,
    idFile: state.idFile,
    packagingType: state.packagingType,
    integrated: state.integrated,
    docDelivered: state.docDelivered,
    processingOrigin: state.processingOrigin,
    idRecollect: state.idRecollect,
    printed: state.printed,
    sampleCurrentTab: state.sampleCurrentTab,
  }),
}

const actions = {
  sampleSetTab: ({ commit }, tab) => {
    commit(SAMPLE_SET_CURRENT_TAB, tab)
    commit(SAMPLE_SET_LOADING_STATUS, 'STATUS_INITIAL')
  },
  getServiceSample: function ({ commit, dispatch, state }) {
    return sampleService
      .getAllSamples(
        state.offset,
        strings.listsLimits.samples,
        state.samplePrintedList,
        state.startDate,
        state.endDate,
        state.orderBy,
        state.q,
        state.dateType,
        state.patientName,
        state.batchLabel,
        state.codeOriginLis,
        state.codeOriginAlvaro,
        state.idFile,
        state.packagingType,
        state.integrated,
        state.docDelivered,
        state.processingOrigin,
        state.idRecollect,
        state.collectionPointName,
        state.printed,
        state.sampleCurrentTab,
        state.sampleStatus,
        state.source
      )
      .then(response => {
        commit(SAMPLE_BREAK_STATUS, false)
        let samples = response.data
        let headers = response.headers

        if (samples && samples.length > 0) {
          samples = samples.map(item => {
            item.expanded = false
            return item
          })
          if (
            state.startDate ||
            state.endDate ||
            state.orderBy ||
            state.q ||
            state.dateType ||
            state.packagingType ||
            state.idFile ||
            state.integrated ||
            state.docDelivered ||
            state.patientName ||
            state.batchLabel
          ) {
            analyticsOnFetchingFromSearch(state)
          }
          commit(SAMPLE_SET, samples)
          commit(SAMPLE_INCREASE_OFFSET)
          if (samples.length === strings.listsLimits.samples) {
            commit(SAMPLE_SET_LOADING_STATUS, 'STATUS_SUCCESS')
          } else {
            commit(SAMPLE_SET_LOADING_STATUS, 'STATUS_END')
          }
          if (state.lastReordenationSample.sort !== null) {
            commit(SAMPLE_SORT_LIST, state.lastReordenationSample)
          }
          commit(
            SAMPLE_SET_NOT_PRINTED,
            parseInt(headers['content-sample-not-printed-number'])
          )
          commit(
            SAMPLE_SET_PRINTED_NUMBER,
            parseInt(headers['content-sample-printed-number'])
          )
        } else {
          commit(SAMPLE_SET_LOADING_STATUS, 'STATUS_END')
        }
        dispatch('countTotalSamplesWithDocPending')
      })
      .catch(() => {
        commit(SAMPLE_SET_LOADING_STATUS, 'STATUS_FAILED')
      })
  },
  setSampleShowOff({ commit }, value) {
    commit(SAMPLE_FILTER_SHOW_OFF, value)
  },
  setWaitingSampleLoadingStatus: function ({ commit }) {
    commit(SAMPLE_SET_LOADING_STATUS, 'STATUS_WAITING')
  },
  clearAllSampleData: function ({ commit }) {
    commit(SAMPLE_SET_LOADING_STATUS, 'STATUS_INITIAL')
    commit(SAMPLE_CLEAR_ALL)
  },
  showDetailsSample: function ({ commit }, index) {
    commit(SAMPLE_SHOW_DETAILS, index)
  },
  selectSampleList: function ({ commit }, samplePrintedList) {
    commit(SAMPLE_SET_LOADING_STATUS, 'STATUS_INITIAL')
    commit(SAMPLE_SET_PRINTED_LIST, samplePrintedList)
  },
  printSamples: function (
    { commit, dispatch, rootState },
    { samplesId, printBatch, source }
  ) {
    if (source === 'AOL2') {
      if (samplesId.length === 0) {
        printBatch = true
        rootState.sample.samples.filter(item => {
          samplesId.push({
            sample_id: item.sample_id,
            batch: {
              id: item.batch_id || null,
            },
          })
        })
      }
    }

    if (samplesId.length > 0 || samplesId.barcodeList.length > 0) {
      commit(SAMPLE_SET_PRINTING_STATUS, 'STATUS_PRINTING')
      return sampleService
        .printTag(samplesId, printBatch, source)
        .then(() => {
          dispatch('clearAllSampleData')
          commit(SAMPLE_SET_PRINTING_STATUS, 'STATUS_INITIAL')

          eventBus.$emit(SAMPLE_PRINTED, samplesId)
        })
        .catch(error => {
          if (error.response.status === 428) {
            commit(SAMPLE_SET_PRINTING_STATUS, 'STATUS_MISSING_CLIENT')
          } else {
            commit(SAMPLE_SET_PRINTING_STATUS, 'STATUS_INITIAL')
            notify({
              title: 'AVISO:',
              message: 'Erro ao imprimir etiquetas. Por favor, tente novamente.',
            })
          }
        })
    } else {
      notify({
        title: 'AVISO:',
        message: 'Nenhuma amostra selecionada para impressão.',
      })
    }
  },
  webSocketPrintSamples: async function (
    { commit, dispatch, state, rootGetters },
    { samplesId, printBatch, batch }
  ) {
    try {
      if (samplesId?.length === 0 && !samplesId.barcodeList?.length) {
        notify({
          title: 'AVISO:',
          message: 'Nenhuma amostra selecionada para impressão.',
        })
        return
      }

      let batchList = []
      let barcodeList = []

      if (samplesId[0]?.batchList) {
        batchList = samplesId[0].batchList
        barcodeList = samplesId[0].barcodeList
      } else {
        batchList = batch?.barcode ? [batch.barcode] : []
        barcodeList = samplesId?.barcodeList
      }

      batchList = [...new Set(batchList)]

      let barcodeResponse
      barcodeResponse = await webSocketPrintService.getAOLWSBarcode({
        barcodeList: barcodeList,
        batch: batchList,
        filterBy: 'SAMPLE',
        printBatch: printBatch,
      })

      if (!batch) {
        batch = {}
      }

      batch['labelCode'] = barcodeResponse.data

      // Verifica se tem impressora configurada
      if (!rootGetters.webSocketStatus.isConfigured) {
        notify({
          type: 'warning',
          title: 'Atenção',
          message: 'Selecione uma impressora para continuar',
        })

        throw new Error('printer_config_required')
      }

      commit(SAMPLE_SET_PRINTING_STATUS, 'STATUS_PRINTING')

      // Envia para impressão via WebSocket
      const response = await PrintWebSocketService.printBatchSamples({
        ...batch,
        printer: rootGetters.webSocketStatus.defaultPrinter,
      })

      if (response.status === 'SUCCESS') {
        if (state.source === 'AOLWS') {
          try {
            await sampleService.printTag(samplesId, printBatch, 'AOLWS')
          } catch (err) {
            console.error('Erro ao registrar impressão de amostras LIS:', err)
          }
        }

        await dispatch('clearAllSampleData')
        commit(SAMPLE_SET_PRINTING_STATUS, 'STATUS_INITIAL')
        commit(SAMPLE_SET_LOADING_STATUS, 'STATUS_INITIAL')
        eventBus.$emit(SAMPLE_PRINTED, samplesId)

        await dispatch('getServiceSample')
      } else {
        throw new Error('print_failed')
      }
    } catch (error) {
      console.error('Erro na impressão:', error)

      if (error.message === 'printer_config_required') {
        commit(SAMPLE_SET_PRINTING_STATUS, 'STATUS_MISSING_CLIENT')
        notify({
          title: 'AVISO:',
          message: 'Configure uma impressora antes de imprimir',
        })
      } else {
        commit(SAMPLE_SET_PRINTING_STATUS, 'STATUS_INITIAL')
        commit(SAMPLE_SET_LOADING_STATUS, 'STATUS_INITIAL')
        notify({
          title: 'AVISO:',
          message: 'Erro ao imprimir etiquetas. Por favor, tente novamente.',
        })
      }

      throw error
    }
  },
  printReceipt: function ({ state }, selected) {
    return new Promise((resolve, reject) => {
      let items
      let ids
      let codeOriginAlvaroList
      if (selected.length === 0) {
        ids = state.samples.map(function (elem) {
          return elem.os_order_id
        })
        codeOriginAlvaroList = state.samples.map(function (elem) {
          return elem.number_alvaro_order.toString()
        })
      }
      if (selected.length > 0) {
        ids = state.samples.map(function (elem) {
          return selected.includes(elem.sample_id) ? elem.os_order_id : null
        })
        codeOriginAlvaroList = state.samples.map(function (elem) {
          return selected.includes(elem.sample_id)
            ? elem.number_alvaro_order.toString()
            : null
        })
      }
      if (ids) {
        ids = ids.filter(function (el) {
          return el != null
        })
      }
      if (codeOriginAlvaroList) {
        codeOriginAlvaroList = codeOriginAlvaroList.filter(function (el) {
          return el != null
        })
      }
      items = { orderIds: ids, codeOriginAlvaroList: codeOriginAlvaroList }
      sampleService
        .printReceipt(items)
        .then(response => {
          let blob = new Blob([response.data], { type: 'application/pdf' })
          let date = new Date()
          let filename = date.toISOString() + '.pdf'
          // Check if is IE or Edge
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, filename)
          } else {
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = filename
            link.style.display = 'none'
            document.body.appendChild(link)
            link.click()
            document.body.appendChild(link)
          }
          resolve()
        })
        .catch(response => {
          notify({
            title: 'AVISO: ',
            message: 'Não foi possível gerar o recibo. Por favor, tente novamente.',
          })
          resolve()
        })
    })
  },
  sortSampleList: function ({ commit }, param) {
    commit(SAMPLE_SORT_LIST, param)
  },
  getTotalSample: function ({ commit, state }) {
    sampleService
      .countTotalSample({
        limit: strings.listsLimits.samples,
        status: state.samplePrintedList,
        startDate: state.startDate,
        endDate: state.endDate,
        orderBy: state.orderBy,
        query: state.q,
        dateType: state.dateType,
        patientName: state.patientName,
        batchLabel: state.batchLabel,
        codeOriginLis: state.codeOriginLis,
        codeOriginAlvaro: state.codeOriginAlvaro,
        idFile: state.idFile,
        packagingType: Array.isArray(state.packagingType)
          ? state.packagingType
          : [state.packagingType],
        integrated: state.integrated,
        orderIds: state.lastTransferedList,
        printed: state.printed,
      })
      .then(response => {
        commit(SAMPLE_TOTAL_COUNT, response.data.samplesCount)
      })
  },
  breakSampleLoading: function ({ commit }) {
    commit(SAMPLE_SET_LOADING_STATUS, 'STATUS_END')
    commit(SAMPLE_CLEAR_ALL)
    commit(SAMPLE_BREAK_STATUS, true)
    window.stop()
  },
  countTotalSamplesWithDocPending: function ({ commit, state }) {
    let total = Object.keys(state.samples).reduce((previous, key) => {
      return previous + state.samples[key].examDocPendingCount
    }, 0)

    commit(SAMPLE_SET_TOTAL_EXAMS_DOC_PENDING, total)
  },
  setSamplePrinted: function ({ commit }, state) {
    commit(SAMPLE_SET_PRINTED, state)
  },
  setSampleIntegrated: function ({ commit }, state) {
    commit(SAMPLE_SET_INTEGRATED, state)
  },
}

let routeStringtoBoolean = function (printed) {
  if (printed === null || printed === undefined || printed === '') {
    return null
  } else if (printed === 'false' || !printed) {
    return false
  }
  return true
}

let analyticsOnFetchingFromSearch = function (state) {
  analytics.pushAnalyticsEvent('ga-search', {
    orderBy: state.orderBy,
    startDate: state.startDate,
    endDate: state.endDate,
    q: state.q,
    dateType: state.dateType,
    patientName: state.patientName,
    batchLabel: state.batchLabel,
    codeOriginLis: state.codeOriginLis,
    codeOriginAlvaro: state.codeOriginAlvaro,
    idFile: state.idFile,
    packagingType: state.packagingType,
    integrated: state.integrated,
    docDelivered: state.docDelivered,
    processingOrigin: state.processingOrigin,
    printed: state.printed,
  })
}

export default {
  state,
  mutations,
  actions,
  getters,
}

export { mutations, actions, getters }
